import React, { useRef } from "react";
import {
  Chart,
  Series,
  ArgumentAxis,
  ValueAxis,
  Legend,
  Tooltip,
  Grid,
  Label,
} from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";
import useRatingSorter from "hooks/useRatingSorter";

const RatingEffectDistribution = ({ data, palette }) => {
  const chartRef = useRef(null);
  const sortedData = useRatingSorter(data, "RatingLib");

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const customizeTooltip = (arg) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            arg.argumentText
          }</div>
          <div><span style="font-weight: 500;">${
            arg.seriesName
          }</span>: ${formatter.format(arg.value)}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard
      title="Rating Effect Distribution"
      chartRef={chartRef}
      palette={palette}
    >
      <div className="p-4">
        <Chart
          dataSource={sortedData}
          id="ratingEffectDistributionChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            valueField="SumRatingEffect"
            argumentField="RatingLib"
            name="Sum of Rating Effect"
            type="bar"
          />

          <ArgumentAxis>
            <Label
              wordWrap="normal"
              textOverflow="ellipsis"
              overlappingBehavior="rotate"
              rotationAngle={45}
            />
          </ArgumentAxis>

          <ValueAxis>
            <Grid visible={true} />
            <Label customizeText={(arg) => formatter.format(arg.value)} />
          </ValueAxis>

          <Legend
            visible={true}
            horizontalAlignment="center"
            verticalAlignment="bottom"
          />

          <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default RatingEffectDistribution;
